import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Menu, Responsive, Image } from 'semantic-ui-react';
import { NavLink } from 'react-router-dom';
import styled, { css } from 'styled-components';

import AuthButton from '../../Containers/AuthButton';
import { Icon } from '../../Components/Base';
import { breakpoints } from '../../Components/Theme';

const MenuStyled = styled(Menu)`
  ${({ secondary }) =>
    !secondary &&
    css`
      border-radius: 0 !important;
    `};

  &.menu .item {
    padding-top: 0.5em;
    padding-bottom: 0.5em;
  }
`;

const MenuItemStyled = styled(Menu.Item)`
  &.item {
  }
`;

const MenuItemRight = styled(MenuItemStyled)`
  &.item {
    padding-left: 0 !important;
  }
`;

const LogoBox = styled.div`
  height: 45px;
  width: 120px;
  align-items: center;
  justify-content: center;
  display: flex;
`;

class MainNav extends Component {
  handleHamburgerClick = () => {
    this.props.toggleSideMenu();
  };
  render() {
    const { logoUrl, rendermenus, showAuth, showLogo, menuProps, isLogin } = this.props;

    return (
      <MenuStyled {...menuProps} borderless>
        {showLogo && (
          <MenuItemStyled>
            <Menu.Header>
              <LogoBox>
                <a href="/" alt="TCASter">
                  <Image src={logoUrl} size="medium" />
                </a>
              </LogoBox>
            </Menu.Header>
          </MenuItemStyled>
        )}
        {rendermenus.map(menu => (
          <MenuItemStyled
            key={menu.path}
            as={NavLink}
            exact={menu.path === '/'}
            to={menu.path}
            content={menu.title}
          />
        ))}
        {isLogin && (
          <Responsive as={Fragment} maxWidth={breakpoints[2] - 1}>
            <Menu.Menu position="right">
              <MenuItemRight name="hamburger">
                <Icon
                  onClick={this.handleHamburgerClick}
                  name={'menu'}
                  iconStyle={{ fontSize: '24px' }}
                />
              </MenuItemRight>
            </Menu.Menu>
          </Responsive>
        )}
        {showAuth && (
          <Responsive as={Fragment} minWidth={isLogin ? breakpoints[2] : null}>
            <Menu.Menu position="right">
              <MenuItemRight name="logout">
                <AuthButton />
              </MenuItemRight>
            </Menu.Menu>
          </Responsive>
        )}
      </MenuStyled>
    );
  }
}

MainNav.propTypes = {
  logoUrl: PropTypes.string,
  menus: PropTypes.arrayOf(
    PropTypes.shape({
      path: PropTypes.string,
      title: PropTypes.string,
      roles: PropTypes.array,
      private: PropTypes.bool,
    }),
  ),
  myRoles: PropTypes.arrayOf(PropTypes.string),
  showAuth: PropTypes.bool,
  showLogo: PropTypes.bool,
};

MainNav.defaultProps = {
  logoUrl: '/images/tcaster_logo.png', // 'https://assets.skooldio.com/logo/logo_forInstructor.png',
};

export default MainNav;
